import { useState } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Droplets, Lock } from "lucide-react";
import { API } from "../lib/constants";
import { Logo } from "../components/Logo";

export const AdminLogin = ({ onLogin }) => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError("");
    try {
      const response = await axios.post(`${API}/admin/login`, { username, password });
      onLogin(response.data.token);
    } catch (err) {
      setError(err.response?.data?.detail || "Errore di autenticazione");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center gradient-hero px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center gap-2 mb-4">
            <Logo size={44} />
            <span className="font-bold text-2xl text-slate-800" style={{ fontFamily: 'Outfit, sans-serif' }}>
              Acqua Vicina
            </span>
          </div>
          <h1 className="text-2xl font-bold text-slate-900" style={{ fontFamily: 'Outfit, sans-serif' }}>
            Area Amministrazione
          </h1>
        </div>

        <form onSubmit={handleSubmit} className="booking-card rounded-3xl p-8" data-testid="admin-login-form">
          <div className="space-y-6">
            <div>
              <Label htmlFor="username" className="text-slate-700 font-medium mb-2 block">Username</Label>
              <Input id="username" value={username} onChange={(e) => setUsername(e.target.value)}
                placeholder="admin" className="h-12 rounded-xl border-slate-200"
                data-testid="admin-username-input" required />
            </div>
            <div>
              <Label htmlFor="password" className="text-slate-700 font-medium mb-2 block">Password</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••" className="h-12 rounded-xl border-slate-200"
                data-testid="admin-password-input" required />
            </div>
            {error && (
              <div className="p-3 bg-red-50 border border-red-200 rounded-xl text-red-600 text-sm" data-testid="login-error">
                {error}
              </div>
            )}
            <Button type="submit" disabled={isLoading} className="w-full btn-primary text-white rounded-full h-12" data-testid="admin-login-btn">
              {isLoading ? (
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
              ) : (
                <><Lock className="w-4 h-4 mr-2" /> Accedi</>
              )}
            </Button>
          </div>
        </form>

        <p className="text-center text-slate-500 text-sm mt-6">
          Credenziali default: admin / admin123
        </p>
      </div>
    </div>
  );
};
